<section class="px-4">
  <div class="activities-header-container">
    <div class="activities-title-container">
      <button class="back_icon me-2" (click)="goBack()">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h1 class="activities-title" translate>Activities List</h1>
    </div>
    <button
      class="btn add_button mat-elevation-z4"
      mat-raised-button
      color="primary"
      (click)="openAddActivityDialog()"
    >
      <i class="fa-solid fa-plus"></i>
      <span translate>Add Activities</span>
    </button>
  </div>
  <div class="mt-2 activity-content">
    <div
      class="activities-card"
      *ngIf="eventList.length > 0; else noDataTemplate"
    >
      <mat-table [dataSource]="eventList" class="mat-elevation-z8">
        <ng-container matColumnDef="id">
          <mat-header-cell *matHeaderCellDef translate>
            Sl. No.
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.id }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="heading">
          <mat-header-cell *matHeaderCellDef translate>
            Heading
          </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.heading }} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef translate>
            Description
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element"
            matTooltip="{{ element.description }}"
          >
            {{ element.description | slice: 0 : 50
            }}<span *ngIf="element.description.length > 50">...</span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="date">
          <mat-header-cell *matHeaderCellDef translate>
            Event Date
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.date | date: "dd/MM/yyyy" }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="images">
          <mat-header-cell *matHeaderCellDef translate>
            Images
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div class="image-container" *ngIf="element.image_urls.length > 0">
              <div class="image-boxes">
                <img
                  *ngFor="let imgObj of element.image_urls; let i = index"
                  [src]="this.imagePath + '/' + imgObj.image_url"
                  alt="Activity Image"
                  class="activity-image"
                  [ngClass]="{
                    first: i === 0,
                    second: i === 1,
                    third: i === 2,
                  }"
                />
              </div>
            </div>
            <span
              *ngIf="!element.image_urls || element.image_urls.length === 0"
              translate
            >
              No images available
            </span>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="actions">
          <mat-header-cell *matHeaderCellDef translate>
            Actions
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <!-- <button mat-raised-button class="view_button">View</button> -->
            <button
              class="action_button"
              mat-icon-button
              [matMenuTriggerFor]="menu"
            >
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </button>
            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                class="update_button"
                (click)="editItem(element)"
              >
                <mat-icon>edit</mat-icon> <span translate>Edit</span>
              </button>
              <button
                mat-menu-item
                class="delete_button"
                (click)="deleteEvents(element)"
              >
                <mat-icon>delete</mat-icon> <span translate>Delete</span>
              </button>
            </mat-menu>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>
    <ng-template #noDataTemplate>
      <div class="no-data">
        <p translate>
          No activities found. Click (+ Add Activities) to add one.
        </p>
      </div>
    </ng-template>
  </div>
</section>
